import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useReactlytics } from 'reactlytics';
import { Button, trackCsEvent } from '@americanexpress/gravity-core';
import Overlay from './Overlay';
import { LANG, SETTINGSDATA } from '../ducks';

const Settings = (props) => {
  /* eslint complexity: ["error", 30] */
  const {
    currentScreenId, queryParams,
    flow: {
      setting: {
        languages,
        commChannelOn, emiOn, payWithPointOn, languageOn,
        preferredLanguage,
      },
    },
    show, data, handleCloseOverlay,
    changeLang, updateSettingsPayloadByType,
    setToggleSettings, toggleSettings, processPayAuthApi,
    updateDataHeader, dataHeader,
  } = props;

  const setLangKey = changeLang ? changeLang.toUpperCase() : preferredLanguage.toUpperCase();

  const [modalName, setModalName] = useState('');
  const [languageKey, setLanguageKey] = useState(setLangKey);
  const { track } = useReactlytics();

  const {
    textMessage, email, pointOptionValue, emiOptionValue,
  } = toggleSettings;

  useEffect(() => {
    track({
      event: {
        element: 'settingsMenu',
        identifier: 'axp-gravity-page-wrapper',
        meta: { acs_trans_id: queryParams.acsTransId, screenId: currentScreenId },
        type: 'impression',
        timestamp: new Date().toISOString(),
      },
    });
    trackCsEvent({
      element: 'settingsMenu', meta: { screenId: currentScreenId },
    }, 'impression', processPayAuthApi, queryParams.acsTransId, queryParams.token, null, dataHeader, updateDataHeader);
  }, []);

  useEffect(() => {
    updateSettingsPayloadByType(SETTINGSDATA, toggleSettings);
  }, [toggleSettings]);

  const onChangeLanguage = (val) => {
    updateSettingsPayloadByType(LANG, val.toLowerCase());
    setLanguageKey(val);
  };

  const onToggleSetting = (name, element) => {
    const newSettings = { ...toggleSettings, [name]: toggleSettings[name] === true || toggleSettings[name] === 'Y' ? 'N' : 'Y' };
    trackCsEvent({
      element, meta: { screenId: currentScreenId },
    }, 'click', processPayAuthApi, queryParams.acsTransId, queryParams.token, `${toggleSettings[name] === 'Y' ? 'n' : 'y'}`, dataHeader, updateDataHeader);
    setToggleSettings(newSettings);
  };

  const commChannelOnToggle = (name, element) => {
    const other = name === 'email' ? 'textMessage' : 'email';
    let update;
    if ((toggleSettings[name] === 'Y' || toggleSettings[name] === true) && (toggleSettings[other] === 'N' || toggleSettings[other] === false)) {
      update = {
        ...toggleSettings,
        [other]: 'Y',
        [name]: 'N',
      };
    } else {
      update = { ...toggleSettings, [name]: toggleSettings[name] === false || toggleSettings[name] === 'N' ? 'Y' : 'N' };
    }
    trackCsEvent({
      element, meta: { screenId: currentScreenId },
    }, 'click', processPayAuthApi, queryParams.acsTransId, queryParams.token, `${toggleSettings[name] === 'Y' ? 'n' : 'y'}`, dataHeader, updateDataHeader);
    setToggleSettings(update);
  };

  const navigateToModal = (e, currentModalName) => {
    e.preventDefault();
    setModalName(currentModalName);
  };

  const renderVerificationCodes = () => data
    && (
      <Overlay
        title={data.verificationOverlay.heading.text}
        data={data.overlay}
        show={show}
        onBack={(e) => navigateToModal(e, '')}
        currentScreenId={currentScreenId}
        queryParams={queryParams}
        modalContent={(
          <div id="verificationBody" className="card-body safekey-card-body">
            {Object.values(data.verificationOverlay.main).map((_item, i) => _item.text
              && (
                <div key={_item.text} id={`verificationBody${i}`} className={`safekey-md${i === 0 ? ' safekey-space-fluid' : ' pad-2-b'}`}>
                  {_item.text}
                </div>
              )
            )}
          </div>
        )}
        modalFooter={(
          <Button
            className="btn btn-tertiary safekey-btn safekey-modal-btn"
            role="button"
            onClick={(e) => navigateToModal(e, '')}
            id="overlayClose1"
            meta="primary Btn"
            aria-label={data.verificationOverlay.actions.primaryBtn.aria}
            identifier="axp-gravity-header"
            element="overlayClose1"
            detail={data.verificationOverlay.actions.primaryBtn.text}
            acsTransId={queryParams.acsTransId}
            screenId={currentScreenId}
          >
            {data.verificationOverlay.actions.primaryBtn.text}
          </Button>
        )}
      />
    );
  const renderLanguageSelectionModal = () => data && languages
    && (
      <Overlay
        data={data.overlay}
        title={data.languageOverlay.heading.text}
        show={show}
        onBack={(e) => navigateToModal(e, '')}
        currentScreenId={currentScreenId}
        queryParams={queryParams}
        modalContent={(
          <div id="languageBody" className="card-body safekey-card-body width-full">
            {languages.map((val, idx) => {
              const isCurrentLang = languageKey === val.toUpperCase();
              return (
                <div key={val} id={`langSelection-${idx}`} className="border-b">
                  <Button
                    id={`lang-${idx}`}
                    className={`safekey-list-option width-full pad-1 text-align-left dls-black flex flex-justify-between flex-align-center${idx === 0 ? ' safekey-margin-2-fluid' : ''}`}
                    role="button"
                    onKeyDown={() => onChangeLanguage(val.toUpperCase())}
                    onClick={() => onChangeLanguage(val.toUpperCase())}
                    identifier="axp-gravity-header"
                    element={`lang-${idx}`}
                    detail={val.toUpperCase()}
                    acsTransId={queryParams.acsTransId}
                    screenId={currentScreenId}
                  >
                    <span className={isCurrentLang ? 'font-weight-bold' : undefined}>{val.toUpperCase()}</span>
                    {isCurrentLang
                    && (
                      <div
                        id={`iconCheckLang-${idx}`}
                        className="glyph dls-glyph-check dls-bright-blue safekey-glyph"
                        name={`selectLanguage-${idx}`}
                      />
                    )}
                  </Button>
                </div>
              );
            })}
          </div>
        )}
        modalFooter={(
          <Button
            className="btn btn-tertiary safekey-btn safekey-modal-btn"
            role="button"
            onKeyDown={(e) => navigateToModal(e, '')}
            onClick={(e) => navigateToModal(e, '')}
            id="overlayClose4"
            aria-label={data.languageOverlay.actions.primaryBtn.aria}
            identifier="axp-gravity-header"
            element="overlayClose4"
            detail={data.languageOverlay.actions.primaryBtn.text}
            acsTransId={queryParams.acsTransId}
            screenId={currentScreenId}
          >
            {data.languageOverlay.actions.primaryBtn.text}
          </Button>
        )}
      />
    );
  const renderOverlayContent = () => (
    <div className="card-body safekey-card-body safekey-card-body-sm">
      {languageOn && languages && languages.length > 1 && (
      <div className="flex flex-justify-between flex-align-items-center safekey-setting-option safekey-info-sm">
        <div>{data.languageOverlay.heading.text}</div>
        <div className="flex">
          <div>{languageKey}</div>
          <Button
            className="icon icon-sm dls-glyph-right margin-1-l safekey-icon-right"
            role="button"
            onKeyDown={(e) => navigateToModal(e, 'languageSelection')}
            onClick={(e) => navigateToModal(e, 'languageSelection')}
            id="languageSelection"
            meta="choose a different language Btn"
            aria-label={data.languageOverlay.changeLangIcon.aria}
            identifier="axp-gravity-header"
            element="languageSelection"
            detail="rightIcon"
            acsTransId={queryParams.acsTransId}
            screenId={currentScreenId}
          />
        </div>
      </div>
      )}
      {commChannelOn
      && (
        <div id="com-channel-on-wrapper">
          <p className="pad-2-t pad-1-b safekey-info-sm border-t" id="verificationLabel">
            {data.settings.main.choose.text}&nbsp;
            <Button
              className="dls-bright-blue"
              role="button"
              onClick={(e) => navigateToModal(e, 'verificationCodes')}
              id="verificationInfo"
              aria-label={data.settings.main.sendCodeLink.aria}
              identifier="axp-gravity-header"
              element="verificationInfo"
              detail={data.settings.main.bypassOtpLink.text}
              acsTransId={queryParams.acsTransId}
              screenId={currentScreenId}
              autoFocus={true}
            >
              {data.settings.main.sendCodeLink.text}
            </Button>
          </p>
          <div className="flex flex-justify-between flex-align-items-center pad-1-tb position-relative safekey-info-sm margin-1-b" id="otcTextDiv">
            <label id="text-message" className="settings-option" htmlFor="toggleTextMsg">
              {data.settings.main.otcSms.text}
            </label>
            <div className="skswitch">
              <button
                id="toggleTextMsg"
                role="checkbox"
                type="button"
                aria-label={data.settings.main.otcSms.aria}
                onKeyDown={() => commChannelOnToggle('textMessage', 'smsOtcOption')}
                onClick={() => commChannelOnToggle('textMessage', 'smsOtcOption')}
                aria-checked={textMessage === 'Y' ? 'true' : 'false'}
                className={`round skslider ${textMessage === 'Y' ? ' checked' : ''}`}
              />
            </div>
          </div>
          <div className="flex flex-justify-between flex-align-items-center pad-1-tb position-relative safekey-info-sm margin-1-b" id="otcEmailDiv">
            <label id="otcEmailLabel" className="settings-option" htmlFor="toggleEmail">
              {data.settings.main.otcEmail.text}
            </label>
            <div className="skswitch">
              <button
                id="toggleEmail"
                role="checkbox"
                type="button"
                aria-label={data.settings.main.otcEmail.aria}
                onKeyDown={() => commChannelOnToggle('email', 'emailOtcOption')}
                onClick={() => commChannelOnToggle('email', 'emailOtcOption')}
                aria-checked={email === 'Y' ? 'true' : 'false'}
                className={`round skslider ${email === 'Y' ? ' checked' : ''}`}
              />
            </div>
          </div>
        </div>
      )}
      {payWithPointOn
      && (
        <div className="flex flex-justify-between flex-align-items-center pad-2-t pad-1-b position-relative safekey-info-sm margin-1-b border-t" id="payWithPointDiv">
          <label
            id="payWithPointLabel"
            className="settings-option"
            htmlFor="togglePointOption"
          >
            {data.settings.main.pwpOption.text}
          </label>
          <div className="skswitch">
            <button
              id="togglePointOption"
              role="checkbox"
              type="button"
              aria-label={data.settings.main.pwpOption.aria}
              onKeyDown={() => onToggleSetting('pointOptionValue', 'pwpOption')}
              onClick={() => onToggleSetting('pointOptionValue', 'pwpOption')}
              aria-checked={pointOptionValue === 'Y' ? 'true' : 'false'}
              className={`round skslider ${pointOptionValue === 'Y' ? ' checked' : ''}`}
            />
          </div>
        </div>
      )}
      {emiOn
      && (
        <div className="flex flex-justify-between flex-align-items-center pad-2-t pad-1-b position-relative safekey-info-sm margin-1-b border-t" id="emiDiv">
          <label
            id="emiLabel"
            className="settings-option"
            htmlFor="toggleEmail"
          >
            {data.settings.main.emiOption.text}
          </label>
          <div className="skswitch">
            <button
              id="toggleEmail"
              role="checkbox"
              type="button"
              aria-label={data.settings.main.emiOption.aria}
              onKeyDown={() => onToggleSetting('emiOptionValue', 'emiOption')}
              onClick={() => onToggleSetting('emiOptionValue', 'emiOption')}
              aria-checked={emiOptionValue === 'Y' ? 'true' : 'false'}
              className={`round skslider ${emiOptionValue === 'Y' ? ' checked' : ''}`}
            />
          </div>
        </div>
      )}
    </div>
  );

  if (modalName === 'languageSelection') {
    return renderLanguageSelectionModal();
  } if (modalName === 'verificationCodes') {
    return renderVerificationCodes();
  }

  return (
    data
    && (
      <Overlay
        title={data.title.text}
        data={data.overlay}
        show={show}
        onClose={() => handleCloseOverlay(toggleSettings, languageKey)}
        queryParams={queryParams}
        currentScreenId={currentScreenId}
        modalContent={(
          <div>
            {renderOverlayContent()}
          </div>
        )}
        modalDisclaimer={(
          <div className="safekey-settings-disclaimer-wrap dls-gray-01-bg safekey-info-xs text-align-center flex flex-justify-center flex-align-center pad-1-tb">
            <div className="dls-gray-05 safekey-settings-disclaimer">
              {data.settings.main.savePrefDisclaimer.text}
            </div>
          </div>
        )}
        modalFooter={(
          <Button
            className="btn btn-tertiary safekey-btn safekey-modal-btn"
            role="button"
            onClick={() => handleCloseOverlay(toggleSettings, languageKey)}
            id="overlayClose3"
            meta="primary Btn"
            aria-label={data.settings.actions.primaryBtn.aria}
            identifier="axp-gravity-header"
            element="overlayClose3"
            detail={data.settings.actions.primaryBtn.text}
            acsTransId={queryParams.acsTransId}
            screenId={currentScreenId}
          >
            {data.settings.actions.primaryBtn.text}
          </Button>
        )}
      />
    )
  );
};

Settings.propTypes = {
  show: PropTypes.bool,
  handleCloseOverlay: PropTypes.func.isRequired,
  setToggleSettings: PropTypes.func.isRequired,
  updateSettingsPayloadByType: PropTypes.func.isRequired,
  changeLang: PropTypes.string,
  flow: PropTypes.shape({
    setting: PropTypes.shape({
      languages: PropTypes.arrayOf(PropTypes.string),
      otcEmailPreference: PropTypes.string,
      otcSmsPreference: PropTypes.string,
      emiOn: PropTypes.bool,
      payWithPointOn: PropTypes.bool,
      preferredLanguage: PropTypes.string,
      commChannelOn: PropTypes.bool,
      languageOn: PropTypes.bool,
    }),
  }),
  toggleSettings: PropTypes.shape({
    languages: PropTypes.arrayOf(PropTypes.string),
    textMessage: PropTypes.string,
    email: PropTypes.string,
    payWithPointOn: PropTypes.bool,
    pointOptionValue: PropTypes.string,
    emiOptionValue: PropTypes.string,
    languageOn: PropTypes.bool,
  }).isRequired,
  data: PropTypes.shape({
    title: PropTypes.string,
    overlay: PropTypes.shape({
      backBtn: PropTypes.shape({
        aria: PropTypes.string,
      }),
      closeBtn: PropTypes.shape({
        aria: PropTypes.string,
      }),
    }),
    bypassOtpOverlay: PropTypes.shape({
      title: PropTypes.string,
      heading: PropTypes.string,
      main: PropTypes.shape({
        paragraph1: PropTypes.string,
        paragraph2: PropTypes.string,
        p3Consent: PropTypes.string,
        p3ForSafekey: PropTypes.string,
        p3Term: PropTypes.string,
      }),
      actions: PropTypes.shape({
        primaryBtn: PropTypes.string,
      }),
    }),
    verificationOverlay: PropTypes.shape({
      heading: PropTypes.string,
      main: PropTypes.shape({
        paragraph1: PropTypes.string,
        paragraph2: PropTypes.string,
      }),
      actions: PropTypes.shape({
        primaryBtn: PropTypes.string,
      }),
    }),
    languageOverlay: PropTypes.shape({
      heading: PropTypes.string,
      changeLangIcon: PropTypes.string,
      actions: PropTypes.shape({
        primaryBtn: PropTypes.string,
      }),
    }),
    settings: PropTypes.shape({
      main: PropTypes.shape({
        consent: PropTypes.string,
        savePrefDisclaimer: PropTypes.string,
        bypassOtpLink: PropTypes.string,
        otcEmail: PropTypes.string,
        otcSms: PropTypes.string,
        pwpOption: PropTypes.string,
        sendCodeLink: PropTypes.string,
        choose: PropTypes.string,
        emiOption: PropTypes.string,
      }),
      actions: PropTypes.shape({
        primaryBtn: PropTypes.string,
      }),
    }),
  }),
  queryParams: PropTypes.shape({
    acsTransId: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired,
  }).isRequired,
  currentScreenId: PropTypes.string.isRequired,
  processPayAuthApi: PropTypes.string.isRequired,
  updateDataHeader: PropTypes.func.isRequired,
  dataHeader: PropTypes.string.isRequired,
};
Settings.defaultProps = {
  flow: {}, show: false, data: {}, changeLang: '',
};

export default Settings;
